 import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpService } from '../../../shared-services/http.service';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private apiServiceRequest: HttpService,
    private _http: HttpClient) { }

  async SearchAlerts(item: any) {
    const baseurl = '/api/Alert/SearchAlerts';
    return await this.apiServiceRequest.SendLocal(baseurl, item).toPromise();
  }

  async CloseAlert(item: any) {
    const baseurl = '/api/Alert/CloseAlert';
    return await this.apiServiceRequest.SendLocal(baseurl, item).toPromise();
  }

  async GetAlertStatistics() {
    const baseurl = '/api/Alert/GetAlertStatistics';
    return await this.apiServiceRequest.getAllLocal(baseurl).toPromise();
  }
}
